import ListingHeader from "../../../components/listingHeader/listingHeader";
import SBEditable from "../../../components/sbEditable/sbEditable";

import GetComponentsFromBloks from "../../../helpers/bloksRenderer";

import styles from "./accordionPanel.module.scss";

/// Blok:accordianPanel
// accordionpanel:blok
///
/// header:string
/// mobile_header:string
function AccordionPanel({ blok }) {
  const bloks = GetComponentsFromBloks(blok.items);

  return (
    <SBEditable blok={blok} withId={blok.anchor}>
      <div className={styles.root}>
        {blok.header ? (
          <ListingHeader>
            <h2 className={styles.header}>{blok.header}</h2>
            <h2 className={styles.mobileHeader}>{blok.mobile_header}</h2>
          </ListingHeader>
        ) : null}
        {bloks}
      </div>
    </SBEditable>
  );
}

export default AccordionPanel;
